import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useState } from "react";

import { RootPaths } from "../App/paths";
import { ClipboardLogo } from "../lib/Content";
import { Button } from "../redesign/components/Button";
import { DEFAULT_SUPPORT_LINKS, SupportContext } from "../support/constants";
import { ContactSupportButton } from "../support/ContactSupportButton";
import { markRestartAttempted, resetApp, shouldShowResetButton } from "./resetApp";
import { ErrorPageTemplate } from "./Template";

export function GenericErrorPage() {
  const [isResetting, setIsResetting] = useState(false);
  let isResetButtonVisible = false;
  try {
    isResetButtonVisible = shouldShowResetButton();
  } catch {
    // Safe default — don't crash the error fallback if storage is inaccessible
  }

  const handleRestart = () => {
    try {
      markRestartAttempted();
    } catch {
      // Best-effort — don't block the restart
    }
    globalThis.location.replace(RootPaths.APP_V2_HOME);
  };

  const handleReset = async () => {
    setIsResetting(true);
    try {
      await resetApp();
    } catch {
      globalThis.location.replace("/");
    }
  };

  return (
    <ErrorPageTemplate
      illustration={<ClipboardLogo />}
      title="Oops! Something went wrong."
      description="We're sorry, but something went wrong. Please try again or contact support if the problem persists."
      actions={
        <Stack spacing={4} width="100%">
          <Button
            fullWidth
            variant="contained"
            size="large"
            disabled={isResetting}
            onClick={handleRestart}
          >
            Restart App
          </Button>
          {isResetButtonVisible && (
            <Stack spacing={2}>
              <Button
                fullWidth
                variant="outlined"
                size="large"
                disabled={isResetting}
                onClick={handleReset}
              >
                Reset App
              </Button>
              <Text
                variant="body2"
                sx={{ color: (theme) => theme.palette.text.secondary, textAlign: "center" }}
              >
                Still seeing this error? Reset the app to clear cached data. You will need to log in
                again.
              </Text>
            </Stack>
          )}
          <ContactSupportButton
            supportContext={SupportContext.ERROR_FALLBACK_SCREEN}
            supportLink={DEFAULT_SUPPORT_LINKS.HOW_TO_CONTACT_SUPPORT}
          >
            Contact Support
          </ContactSupportButton>
        </Stack>
      }
    />
  );
}
